import { render, staticRenderFns } from "./testAdministrator.vue?vue&type=template&id=4a5ab6d6"
import script from "./testAdministrator.vue?vue&type=script&lang=js"
export * from "./testAdministrator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports